import { EventBase } from "@vp/models";

export interface ChatMessageCreatedEventArgs {
  conversationId: string;
  messageId: string;
}

/**
 * Pushed to a conversation's members when a message is posted. It carries ids
 * only, never the body: readers fetch the message through the participant-gated
 * read, so the push never widens who can see what.
 */
export class ChatMessageCreatedEvent extends EventBase<ChatMessageCreatedEventArgs> {
  constructor(eventArgs: ChatMessageCreatedEventArgs) {
    super();
    this.args = eventArgs;
  }
}
